import { useQuery } from 'react-query';

import { Deal, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDealQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.Root(guid),
		() => AxiosUtils.getResponseData<Deal>(api.get(CerebroApiEndpoints.Deals.Root(guid))),
		{ enabled: guid !== undefined }
	);
}
